import {
  Box,
  Chevron,
  Div,
  H5,
  Icon,
  Img,
  isAdmin,
  PosConnectionTypeComponent,
  ProviderConnectionStatusComponent,
  ProviderStatusComponent,
  renderPosImage,
  renderPosName,
  TooltipWrapper,
  VerticalSeparator,
} from '@vgrubs/components';
import {
  PosConnectionType,
  PosType,
} from 'components/src/types/api/location.types';
import {
  ProviderConnectionStatus,
  ProviderStatus,
} from 'components/src/types/shared.types';
import { useState } from 'react';
import { PosConnectModal } from './PosConnectModal';
import { PosDetailsModal } from './PosDetails';

export const PosComponent = ({
  provider,
  id,
  status,
  pathPrefix,
  getProvidersStatuses,
  disabled,
  disabledBecauseOfOtherPosConnected,
  onOpenPlaybook,
}: {
  provider: PosType;
  id: string | number;
  status:
    | {
        type: PosType;
        status: ProviderStatus;
        connectionStatus: ProviderConnectionStatus;
        connectionType: PosConnectionType;
      }
    | undefined;
  pathPrefix: 'locations' | 'brands';
  getProvidersStatuses: (silent?: boolean) => void;
  disabled: boolean;
  disabledBecauseOfOtherPosConnected: boolean;
  onOpenPlaybook?: () => void;
}) => {
  const [providerDetailsModal, setProviderDetailsModal] = useState(false);
  const [providerConnectModal, setProviderConnectModal] = useState(false);

  const onlineStatus = status?.status;
  const connectionStatus = status?.connectionStatus;
  const connectionType = status?.connectionType;

  const handleProviderClick = () => {
    if (
      connectionStatus === ProviderConnectionStatus.connected ||
      connectionStatus === ProviderConnectionStatus.waiting ||
      connectionStatus === ProviderConnectionStatus.rejected ||
      connectionStatus === ProviderConnectionStatus.disabled ||
      connectionStatus === ProviderConnectionStatus.waitingMenu ||
      connectionStatus === ProviderConnectionStatus.inProgress
    ) {
      setProviderDetailsModal(true);
    } else {
      setProviderConnectModal(true);
    }
  };

  return (
    <>
      <TooltipWrapper
        $width="100%"
        tooltip={
          disabled
            ? 'Connection to this POS integration is not available.'
            : disabledBecauseOfOtherPosConnected
            ? 'A location can only be connected to one POS system at a time.'
            : undefined
        }
      >
        <Box
          $mb="8"
          $flex
          $alignCenter
          $between
          onClick={handleProviderClick}
          $pointer={!disabled || !disabledBecauseOfOtherPosConnected}
          $opacity={disabled || disabledBecauseOfOtherPosConnected ? 0.5 : 1}
          $notAllowed={disabled || disabledBecauseOfOtherPosConnected}
        >
          <Div $flex $alignCenter $height="50px" $heightSM="50px">
            <Img
              $width="65px"
              $widthSM="50px"
              src={renderPosImage(provider)}
              alt="provider"
            />
            <VerticalSeparator $m="0 16px" $mSM="0 12px" $h="50px" />
            <Div>
              <H5 $mb="0">{renderPosName(provider)}</H5>
              {/* <P $mb="0" mt='4'>{renderProviderPhone(provider)}</P> */}
            </Div>
          </Div>
          <Div
            $flex
            $alignCenter
            $columnSM
            $alignEndSM
            $gap="12px"
            $gapSM="4px"
          >
            {isAdmin && connectionType && (
              <PosConnectionTypeComponent connectionType={connectionType} />
            )}

            {onlineStatus && (
              <ProviderStatusComponent
                status={onlineStatus as ProviderStatus}
              />
            )}

            {connectionStatus && (
              <ProviderConnectionStatusComponent
                status={connectionStatus as ProviderConnectionStatus}
              />
            )}
            {!onlineStatus && !connectionStatus && !disabled && (
              <Icon $rotate="90deg">
                <Chevron />
              </Icon>
            )}
          </Div>
        </Box>
      </TooltipWrapper>
      <PosDetailsModal
        modalIsOpen={providerDetailsModal}
        closeModal={() => {
          setProviderDetailsModal(false);
        }}
        provider={provider}
        id={id}
        pathPrefix={pathPrefix}
        getProvidersStatuses={getProvidersStatuses}
        onOpenPlaybook={onOpenPlaybook}
      />
      <PosConnectModal
        getProvidersStatuses={getProvidersStatuses}
        modalIsOpen={providerConnectModal}
        closeModal={() => {
          setProviderConnectModal(false);
        }}
        provider={provider}
        id={id}
        pathPrefix={pathPrefix}
      />
    </>
  );
};
